/* eslint-disable no-param-reassign */
import _ from 'lodash';
import { GAME_ID, REDUX_ACTIONS, INSTRUCTION_STAGES } from 'a/estaOAquella/data/constants';
import { retrieveInstructionContent } from '../../content/curriculum';

export const initialState = {
  columnShiftStep: 30,
  instructionStage: INSTRUCTION_STAGES.INTRO,
  targetCell: {},
  vowels: [],
  highlightedCell: null,
  hiddenCells: [],
  cells: [],
};

let cells = [];
let newCell = null;
let instructionContent = null;

const instructionReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.INIT_INSTRUCTION:
      instructionContent = retrieveInstructionContent();

      return {
        ...initialState,
        ...instructionContent,
        highlightedCell: instructionContent.targetCell.id,
        cells: [instructionContent.targetCell],
      };
    case REDUX_ACTIONS.CHANGE_INSTRUCTION_STAGE:
      return { ...state, instructionStage: action.payload.instructionStage };

    case REDUX_ACTIONS.UPDATE_CELL_POSITION:
      cells = _.cloneDeep(state.cells);
      newCell = cells.find(cell => cell.id === action.payload.id);
      newCell.row_index = action.payload.rowIndex;
      newCell.column_index = action.payload.columnIndex;

      return {
        ...state,
        cells,
      };
    case REDUX_ACTIONS.SET_COLUMN_SHIFT_STEP:
      return {
        ...state,
        columnShiftStep: action.payload.columnShiftStep,
      };
    case REDUX_ACTIONS.MOVE_COLUMN:
      cells = _.cloneDeep(state.cells);
      cells.forEach((cell) => {
        if (
          cell.column_index === action.payload.columnIndex &&
          state.vowels.find(vowel => vowel.id === cell.id)
        ) {
          cell.column_index = action.payload.newColumnIndex;
        }
      });

      return {
        ...state,
        cells,
      };
    case REDUX_ACTIONS.ADD_CELLS:
      return {
        ...state,
        cells: [...state.cells, ...action.payload.cells],
      };
    case REDUX_ACTIONS.REMOVE_CELLS:
      cells = state.cells;
      cells = cells.filter(cell => !action.payload.cells.includes(cell.id));

      return {
        ...state,
        cells,
      };
    case REDUX_ACTIONS.SET_MAGNIFIED_CELL:
      return { ...state, magnifiedCell: action.payload.magnifiedCell };
    case REDUX_ACTIONS.SET_HIGHLIGHTED_CELL:
      return { ...state, highlightedCell: action.payload.highlightedCell };
    case REDUX_ACTIONS.SET_HIDDEN_CELLS:
      return { ...state, hiddenCells: action.payload.hiddenCells };
    default:
      return state;
  }
};

export default instructionReducer;
